import crel from 'crel';
import L10n from '../../l10n/index.js';
export default class CircleButton {
    constructor(level, actions, highlighter, minutes, enableHelpers) {
        this.wrapper = null;
        this.circle = null;
        this.level = null;
        this.circle = crel('div', {
            class: 'kj-circle',
            style: `background-color: ${highlighter.hlColor}`,
        });
        const hasTooltip = (enableHelpers) ? ({
            tooltip: (minutes > 1) ? L10n.gettext('minutes_reading', Math.round(minutes))
                : L10n.gettext('less_than_min')
        }) : {};
        this.wrapper = crel('div', Object.assign({ role: 'button' }, hasTooltip));
        this.level = level;
        this.wrapper.appendChild(this.circle);
        actions.map((eventAction) => this.circle.addEventListener(eventAction.name, () => eventAction.action()));
    }
    toggleActive(active) {
        if (active) {
            this.circle.classList.add('active');
        }
        else if (this.circle.classList.contains('active')) {
            this.circle.classList.remove('active');
        }
    }
    updateTooltip(minutes) {
        this.wrapper.setAttribute('tooltip', (minutes > 1) ? L10n.gettext('minutes_reading', Math.round(minutes))
            : L10n.gettext('less_than_min'));
    }
    init(view) {
        view.appendChild(this.wrapper);
    }
    destroy() {
        this.wrapper.parentElement.removeChild(this.wrapper);
    }
}
